import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var VatIssueIA = function VatIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "41zbB/",
    defaultMessage: [{
      "type": 0,
      "value": "For an order that is shipping cross-border within the EU, Faire will charge VAT at checkout, based on the ship-to country. If the retailer has not provided a VAT number, here are some steps you can take:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "N1WrAx",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Message the retailer:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "vd648L",
    defaultMessage: [{
      "type": 0,
      "value": "Use "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire messaging"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " to reach out to the retailer directly to enquire if the retailer has a VAT number that is registered for intra-Community trade. If the retailer confirms they do have a VAT number for intra-Community trade, then ask the retailer to add their VAT number to their own account settings on Faire to ensure the correct VAT treatment is applied. This should result in 0% VAT being applied to unfulfilled orders from EU brands."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "LokvZV",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Postpone fulfilment:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "eFvj9E",
    defaultMessage: [{
      "type": 0,
      "value": "Consider postponing the shipment of the order until the retailer has the opportunity to add their VAT number to their account. For further comprehensive guidelines, visit "
    }, {
      "children": [{
        "type": 0,
        "value": "How does VAT work for EU orders"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "?"
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return HCFormatting(chunks);
      }
    }
  })))));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var HCFormatting = function HCFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360057747911"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};